import { ListSelectionStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, map, some } from 'lodash';
import React, { Fragment } from 'react';
import { milestoneFlagList } from './mock';

export const MilestoneFlags: React.FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();
  return (
    <Fragment>
      <Box data-testid="success" flexDirection={{ sm: 'column' }}>
        <SubListSelectionStyled
          onClick={() => {
            if (form.values.filterByMilestone?.length !== milestoneFlagList.length) {
              form.setFieldValue(
                'filterByMilestone',
                map(milestoneFlagList, (flag) => flag.value)
              );
            } else {
              form.setFieldValue('filterByMilestone', []);
            }
          }}
        >
          <Box alignItems={{ sm: 'center' }}>
            <Box mr={{ sm: '500' }}>
              <Checkbox
                checked={form.values.filterByMilestone?.length === milestoneFlagList.length}
                readOnly
                indeterminate={
                  form.values.filterByMilestone?.length > 0 &&
                  form.values.filterByMilestone?.length < milestoneFlagList.length
                }
              />
            </Box>
            <Text size="400" weight="600" color="bechtel.grey.1000">
              <Trans>Milestone Flags</Trans>
            </Text>
          </Box>
          {form.values.filterByMilestone && form.values.filterByMilestone.length > 0 && (
            <Text size="400" color="bechtel.grey.1000">
              {form.values.filterByMilestone.length} <Trans>Selected</Trans>
            </Text>
          )}
        </SubListSelectionStyled>
        <FieldArray name="filterByMilestone">
          {(arrayHelpers) => {
            return (
              <>
                {milestoneFlagList &&
                  milestoneFlagList.map((milestoneFlag) => {
                    return (
                      <ListSelectionStyled
                        key={milestoneFlag.value}
                        data-testid={`planning-wp-search-milestone-flag-${milestoneFlag.id}`}
                        onClick={() => {
                          const selected = findIndex(form.values.filterByMilestone, (item) => {
                            return item === milestoneFlag.value;
                          });
                          if (selected !== -1) {
                            arrayHelpers.remove(selected);
                          } else {
                            arrayHelpers.push(milestoneFlag.value);
                          }
                        }}
                      >
                        <Box mr={{ sm: '500' }}>
                          <Checkbox
                            checked={some(form.values.filterByMilestone, (item) => {
                              return item === milestoneFlag.value;
                            })}
                            readOnly
                          />
                        </Box>
                        <Text size="400" color="bechtel.grey.1000">
                          {i18n._(milestoneFlag.label)}
                        </Text>
                      </ListSelectionStyled>
                    );
                  })}
              </>
            );
          }}
        </FieldArray>
      </Box>
    </Fragment>
  );
};
